'use client';

import { createContext } from 'react';

import { SiteConfigResponseDto } from '@sola/schema/lib/contentful.js';

export const SiteConfigContext = createContext<
  SiteConfigResponseDto | undefined
>(undefined);
